import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import * as ccStudyParticipantActions from './cc-study-participant.actions';
import { CcStudyParticipant } from '../../../../models/cc-study-participant';

export const ccStudyParticipantAdapter: EntityAdapter<CcStudyParticipant> = createEntityAdapter<CcStudyParticipant>({});

export interface CcStudyParticipantState extends EntityState<CcStudyParticipant> {
  loadingCcStudyParticipants: boolean;
  ccStudyParticipantsLoaded: boolean;
}

export const initialCcStudyParticipantState: CcStudyParticipantState = ccStudyParticipantAdapter.getInitialState({
  loadingCcStudyParticipants: false,
  ccStudyParticipantsLoaded: false,
});

export const reducer = createReducer(
  initialCcStudyParticipantState,
  on(ccStudyParticipantActions.getCcStudyParticipants, (state) => {
    return {
      ...state,
      loadingCcStudyParticipants: true,
      ccStudyParticipantsLoaded: false,
    };
  }),
  on(ccStudyParticipantActions.getCcStudyParticipantsSuccess, (state, { ccStudyParticipants }) => {
    return ccStudyParticipantAdapter.setAll(ccStudyParticipants, {
      ...state,
      loadingCcStudyParticipants: false,
      ccStudyParticipantsLoaded: true,
    });
  }),
  on(ccStudyParticipantActions.getCcStudyParticipantsError, (state) => {
    return {
      ...state,
      loadingCcStudyParticipants: false,
      ccStudyParticipantsLoaded: false,
    };
  }),
  on(ccStudyParticipantActions.deleteCcStudyParticipantSuccess, (state, { deletedCcStudyParticipantId }) => {
    return ccStudyParticipantAdapter.removeOne(deletedCcStudyParticipantId, {
      ...state,
    });
  })
);

export function ccStudyParticipantReducer(state: CcStudyParticipantState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectAll } = ccStudyParticipantAdapter.getSelectors();
